import { useTranslation } from 'react-i18next';
import { Tooltip } from '@/components/Tooltip';

/**
 * Floating "jump to the latest messages" button — fades in once the user has
 * scrolled up, smooth-scrolls to the bottom on click. Our own take: a circular
 * surface pill with a soft shadow that flips to the accent on hover.
 */
export function JumpToLatest({ show, onClick, bottomInset = 0 }: { show: boolean; onClick: () => void; bottomInset?: number }) {
  const { t } = useTranslation();
  return (
    <div
      style={bottomInset > 0 ? { bottom: bottomInset + 12 } : undefined}
      className={
        'chat-jump-latest absolute bottom-4 right-4 z-20 transition-[transform,background-color,border-color,color,box-shadow,opacity] duration-200 ' +
        (show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0')
      }
    >
      <Tooltip label={t('messages.jumpToLatest')} side="left">
        <button
          type="button"
          onClick={onClick}
          aria-label={t('messages.jumpToLatestAria')}
          className="grid size-11 place-items-center rounded-lg bg-surface text-ink-dim shadow-[var(--overlay-shadow)] ring-1 ring-separator transition-[transform,background-color,border-color,color,box-shadow,opacity] hover:scale-105 hover:bg-accent hover:text-white hover:ring-accent active:scale-95"
        >
          <svg
            viewBox="0 0 24 24"
            className="size-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
      </Tooltip>
    </div>
  );
}
